module.exports = __webpack_public_path__ + "img/fig12.0a999a97.jpg";